import {AfterViewInit, Component, ElementRef, OnDestroy, ViewChild} from '@angular/core';
import {fromEvent, Subscription} from "rxjs";
import {startWith} from "rxjs/operators";

@Component({
    selector: 'app-huna-toolbar',
    templateUrl: './huna-toolbar.component.html',
    styleUrls: ['./huna-toolbar.component.scss'],
    standalone: false
})
export class HunaToolbarComponent implements AfterViewInit, OnDestroy {
    @ViewChild('CONTAINER') container?: ElementRef<HTMLDivElement>;
    heigthContainer: string | undefined
    widthContainer: string | undefined
    private resizeObserver: ResizeObserver;

    constructor() {
        this.resizeObserver = new ResizeObserver(entries => {
            this.resize()
        });
    }

    ngAfterViewInit() {
        this.resizeObserver.observe(this.container?.nativeElement!);

    }

    ngOnDestroy() {
        this.resizeObserver.disconnect()
    }


    resize() {
        setTimeout(() => {
            if (this.container) {
                this.widthContainer = this.container.nativeElement.clientWidth + 'px';
                this.heigthContainer = this.container.nativeElement.clientHeight + 'px';
            }
        })
    }

}
